// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { WarningAmberRounded } from '@/constants/hardfin-standard-icons';
import { Box, Collapse, Tooltip } from '@mui/material';

interface Props {
  /**
   * If true, the warning icon will be displayed.
   */
  isOpen: boolean;

  /**
   * The tooltip to display when the warning icon is hovered over.
   */
  tooltip: string | null;

  /**
   * If true, the warning icon will have a vertical offset to compensate for
   * the height of the input component's helper text.
   */
  isOffset?: boolean;
}

/**
 * A collapsible warning icon that displays a tooltip when hovered over.
 */
export function FormInputWarning(props: Props) {
  return (
    <Collapse orientation="horizontal" in={props.isOpen}>
      <Tooltip arrow placement="right" title={props.tooltip}>
        <Box display="flex" alignItems="center" marginLeft={1}>
          <WarningAmberRounded
            fontSize="small"
            color="warning"
            // Unfortunately, Material UI does not expose sizing values for the
            // form helper text component. This '19px' value roughly matches the
            // height of the form helper text component, and is necessary to
            // vertically align the warning icon with an input that has helper
            // text.
            sx={{ marginBottom: props.isOffset ? '19px' : undefined }}
          />
        </Box>
      </Tooltip>
    </Collapse>
  );
}
